<template>

  <div class="d-flex justify-space-between">

    <div>
      <span v-if="costBounds" :class="{'font-italic': spot}">
        {{ currencyFormatter.format(costBounds.min) }}
        <template v-if="costBounds.max > costBounds.min">
          – {{ currencyFormatter.format(costBounds.max) }}
        </template>
      </span>
      <template v-else>
        ?
      </template>
    </div>

    <div>

      <uri-daily-rates-set-all
        v-if="bulkUpdate && !disabled"
        @set="cost => model.forEach(z => z.channelCost = cost)"
      />

      <v-btn
        v-if="collapsible"
        :icon="collapsed ? '$expand' : '$collapse'"
        @click="collapsed = !collapsed"
        density="compact"
        class="ml-2"
        size="small"
      />

    </div>

  </div>

  <v-expand-transition group>
    <uri-daily-rate
      v-if="!collapsed"
      v-for="(_, n) in model.length"
      v-model="model[n].channelCost"
      :original-channel-cost="model[n].originalChannelCost"
      :default-channel-cost="context.defaultRate.channelDefaultRates.get(model[n].channelFacility.ID)?.channelCost ?? null"
      :channel="model[n].channelFacility.channel"
      :ex-channel-id="model[n].channelFacility.externalFacilityID"
      class="mt-2"
      :disabled="disabled"
    />
  </v-expand-transition>

</template>

<script setup lang="ts">

import { computed, ref } from 'vue'

// components
import UriDailyRate from './UriDailyRate.vue'
import UriDailyRatesSetAll from './UriDailyRatesSetAll.vue'

// misc
import { currencyFormatter } from '../../../../utils/formatters'
import type { ChannelDefaultRateFieldState } from '../../../../types/misc'
import type { UriLpContext } from './types'

interface Props {
  collapsible?: boolean
  collapsed?: boolean
  disabled?: boolean
  bulkUpdate?: boolean
  context: UriLpContext
}

const props = withDefaults(defineProps<Props>(), {
  collapsible: true,
  collapsed: true,
  disabled: false,
  bulkUpdate: true,
})

const collapsed = ref<boolean>(props.collapsed)

const model = defineModel<ChannelDefaultRateFieldState[]>({default: []})

const costBounds = computed<null | {min: number, max: number}>(() => {
  const costs = model.value.filter(cdr => cdr.channelCost !== null).map(cdr => cdr.channelCost!)
  return costs ? {min: Math.min(...costs), max: Math.max(...costs)} : null
})

const spot = computed<boolean>(() => {

  return model.value.some(cdr => {
    const defaultChannelCost = props.context.defaultRate.channelDefaultRates.get(cdr.channelFacility.ID)?.channelCost ?? null
    // @ts-ignore
    return defaultChannelCost !== null && ![null, undefined, ''].includes(cdr.channelCost) && cdr.channelCost !== defaultChannelCost
  })

})

</script>
